export default "__VITE_ASSET__xa$rzszO__"